import { Form, Offcanvas } from "react-bootstrap";
import styled from "styled-components";

export const CustomOffCanvas = styled(Offcanvas)`
box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.12), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 8px 10px -5px rgba(0, 0, 0, 0.20);
border:none;
min-width: 480px  !important;
  .offcanvas-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    border:none;
  }
  .offcanvas-title {
    margin-bottom: 0;
    font-size: 20px;
    padding: 8px 8px;
    line-height: 1.5;
  }
  .offcanvas-body {

    padding: 0.5rem;
    padding-top: 0px;
    .nav {
      justify-content: space-between;
    }
    .nav-item{
      /* width:33%; */
      button {
        width: 100%;
        font-size: 14px;
        letter-spacing: 0.4px;
        padding: 0.5rem 0;

      }
    }
    .nav-tabs {
      border-bottom: 1px solid  #F0F0F0;
    }
    .nav-tabs .nav-link{
      color: rgba(0, 0, 0, 0.60)!important;

    }
    .nav-tabs .nav-link:hover {
      color: #333333!important;
      background-color: #fff!important;
      border-bottom: 1px solid #333333 !important;
    }
    .nav-tabs .nav-link.active {
      color: #333333!important;
      background-color: #fff!important;
      border-bottom: 1px solid #333333 !important;
      font-weight: 500;
    }

  }
  .offcanvas-footer{
        border-top: 1px solid var(--color-Grey-Border, #D9D9D9);
        padding: 1rem;
        padding-bottom: 2rem;
    }

`
interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
  justify?: string;
  align?: string;
  gap?: number | string;
  vertical?: boolean;
  background?: string;
  key?: string;
}
export const Flex = styled.div<FlexProps>`
  display: flex;
  justify-content: ${props => props.justify || 'flex-start'};
  align-items: ${props => props.align || 'flex-start'};
  gap: ${props => props.gap || 0}px ;
  flex-direction: ${props => props.vertical ? 'column' : 'row'};
  background: ${props => props.background || 'transparent'};


`
export const WrapperPopup = styled.div`
background: "#fff";
border: 1px solid #F0F0F0;
`
export const Switch = styled(Form.Switch)`
	line-height: 1.5 !important;
	.form-check-input {
		background-color: #ffffff;
		border-color: #c4c4c4;
	}
	input[type="checkbox" i] {
		cursor: ${(props) => (props.isdisabled === "true" ? "not-allowed" : "pointer")}!important;
	}
	.form-check-input:checked {
		background-color: #333333;
		border-color: #333333;
	}

	.form-check-input:focus {
		border-color: none;
		box-shadow: none;
	}
`;
